module.exports = __webpack_public_path__ + "static/media/CVC.5f9199d0.jpg";